import * as z from 'zod'
import { User } from '~/shared/api'

export const loginPhoneSchema = User.schema.pick({ phone: true })
export type LoginPhoneFormValues = z.infer<typeof loginPhoneSchema>
